// extracted by mini-css-extract-plugin
module.exports = {"width":"FilterOption_width__1wDg-"};